import {authenticationService} from "./AuthenticationService";

const getScores = () => {
    const requestOptions = {
        method: 'GET'
    }

    return fetch(`/api/getscores`, requestOptions)
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                if (response.status === 403) authenticationService.logout()
                throw new Error(response.statusText + " (" + response.status + ")")
            }
        })
}

export const scoreService = {
    getScores
}